import { RouterModule, Routes } from '@angular/router';

import { Authority } from './shared/constants/authority.constants';
import { FeatureRouteAccessService } from './core/auth/feature-route-access-service';
import { FeaturesEnum } from './shared/constants/features.constants';
import { IDS_POPUP_ROUTES } from './ids/ids.route';
import { LoginComponent } from './account/login/login.component';
import { NgModule } from '@angular/core';
import { UserRouteAccessService } from './core/auth/user-route-access-service';
import { BlankComponent } from './layouts/blank/blank.component';
import { errorRoute } from './layouts/error/error.route';
import { navbarRoute } from './layouts/navbar/navbar.route';
import { StripeRedirectComponent } from './entities/card-extension/stripe-redirect/stripe-redirect.component';
import { PayspotComponent } from './entities/card-extension/payspot/payspot.component';
import { UsloviKoriscenjaComponent } from './entities/card-extension/payspot/uslovi-koriscenja/uslovi-koriscenja.component';
import { TermsOfUseComponent } from './legal/terms-of-use/terms-of-use.component';
import { PrivacyPolicyComponent } from './legal/privacy-policy/privacy-policy.component';
// import { DEBUG_INFO_ENABLED } from './app.constants';

const LAYOUT_ROUTES = [navbarRoute, ...errorRoute];

const IDS_ROUTES = [
  {
    data: {
      featureId: FeaturesEnum.USER_ADMINISTRATION,
    },
    path: 'ids',
    canActivate: [FeatureRouteAccessService],
    loadChildren: () => import('./ids/ids.module').then((m) => m.IdsModule),
  },
  ...IDS_POPUP_ROUTES,
];

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    data: {
      authorities: [],
      pageTitle: 'login.title',
    },
  },
  {
    path: 'admin',
    data: {
      authorities: [Authority.ADMIN],
    },
    canActivate: [UserRouteAccessService],
    loadChildren: () => import('./admin/admin-routing.module').then((m) => m.AdminRoutingModule),
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'payment/stripe',
    component: StripeRedirectComponent
  },
  {
    path: 'payment/payspot',
    component: PayspotComponent
  },
  {
    path: 'payspot/uslovi-koriscenja',
    component: UsloviKoriscenjaComponent
  },
  {
    path: 'terms-of-use',
    component: TermsOfUseComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'booking',
    loadChildren: () => import('./booking/booking.module').then((m) => m.BookingModule),
  },
  ...IDS_ROUTES,
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'chat',
    loadChildren: () => import('./chat/chat.module').then((m) => m.ChatModule),
  },
  {
    path: 'angular-material-preview',
    loadChildren: () =>
      import('./layouts/angular-material-preview/angular-material-preview.module').then(
        (m) => m.AngularMaterialPreviewModule
      ),
  },
  {
    path: 'blank',
    component: BlankComponent,
  },
  ...LAYOUT_ROUTES,
];

@NgModule({
  imports: [RouterModule.forRoot(routes /*, { enableTracing: DEBUG_INFO_ENABLED }*/)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
